import { DeleteIcon, SortIcon, TuneIcon } from '@sharedCR/coreDesignSystem/icons';

import { PopupDynamicFieldView } from 'constants/formBuilder';

export const LABELS_BY_VIEW = {
  [PopupDynamicFieldView.STYLE_OPTIONS_VIEW]: 'Edit formatting',
  [PopupDynamicFieldView.RATE_CURRENCY_OPTIONS]: 'Edit format options',
  [PopupDynamicFieldView.TODAYS_DATE_PLUS_NUMBER]: 'Edit date offset',
  [PopupDynamicFieldView.HAND_WRITING_SIGNATURE_OPTIONS]: 'Edit signature options',
  [PopupDynamicFieldView.NOTARY_OPTIONS_VIEW]: 'Edit notary options',
  [PopupDynamicFieldView.FIELDS_LIST_VIEW]: 'Change field',
};

export const HEADER_STACK_SPACING = 1;
export const ACTIONS_STACK_SPACING = 0.5;

export const ChangeFieldIcon = SortIcon;
export const FormatIcon = TuneIcon;
export const DeleteFieldIcon = DeleteIcon;
